/****************************************************
 * Module Name:  DnkProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class DnkProxy {
    static GetInvoiceDataByCustomerid = (customerid, data, callback) => {
        restAPICall(
            Constants.UTILITY_URL + `/dnk/sales/${customerid}`,
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };
}
